import { Controller } from "@hotwired/stimulus"

// App-specific Lexxy behavior configured per editor through data attributes.
export default class extends Controller {
  static values = { initialFormat: String }

  connect() {
    if (this.hasInitialFormatValue) {
      this.element.addEventListener("lexxy:focus", this.applyInitialFormat, { once: true })
    }
  }

  disconnect() {
    this.element.removeEventListener("lexxy:focus", this.applyInitialFormat)
  }

  applyInitialFormat = () => {
    if (!this.element.isEmpty) return

    this.element.editor.update(() => this.element.contents.applyHeadingFormat(this.initialFormatValue))
  }
}
